export default __webpack_public_path__ + "static/media/intro.2a63769e.webp";